// extracted by css-extract-rspack-plugin
export default {"tableBrowserItemButtons":"PaUMa"};